/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
export class UserDefaultSettingEntity extends Entity {
  appId: string | null = null;
  createdAt: string | null = null;
  env: string | null = null;
  id: string = '';
  name: string | null = null;
  updatedAt: string | null = null;
  value: string | null = null;
  static override key = 'UserDefaultSetting';
  static override schema = {};
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'UserDefaultSetting' in input
    ) {
      const { UserDefaultSetting: wrapped, ...rest } = input as {
        UserDefaultSetting: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}